import React, { useEffect, useRef } from 'react';
import DropzoneComponent from 'react-dropzone-component';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import { setLoaderStart, setLoaderComplete } from '../../../actions/loader/loader';
import { errorFileFormat } from './fileFormat';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';

import s from '../../../styles/adminDropzone.css';

const ImageUploadComponent = ({
  defaultMessage,
  className,
  subTextClass,
  subText,
  componentConfig,
  success,
  maxUploadSize,
  loaderName,
  setLoaderStart,
  setLoaderComplete
}) => {
  const dropzoneRef = useRef(null);

  useEffect(() => {
    const isBrowser = typeof window !== 'undefined';
    const isDocument = typeof document !== 'undefined';

    if (isBrowser && isDocument) {
      const inputEl = document.querySelector(".dz-hidden-input");
      if (inputEl) {
        inputEl.style.visibility = 'visible';
        inputEl.style.opacity = '0';
        inputEl.style.height = '100%';
        inputEl.style.width = '100%';
        inputEl.style.cursor = 'pointer';
      }
    }
  }, []);

  const handleError = (file) => {
    if (loaderName) setLoaderComplete(loaderName);
    errorFileFormat(file, maxUploadSize);
  };

  const handleComplete = () => {
    if (dropzoneRef.current) {
      dropzoneRef.current.files = [];
    }
    if (loaderName) setLoaderComplete(loaderName);
  };

  const handleAddedFile = (file) => {
    const isOnline = typeof window !== 'undefined' && window.navigator.onLine;

    if (!isOnline) {
      showToaster({ messageId: 'networkFailed', toasterType: 'error' });
      dropzoneRef.current.removeFile(file);
      if (loaderName) setLoaderComplete(loaderName);
      return;
    }

    if (loaderName) setLoaderStart(loaderName);
  };

  const eventHandlers = {
    init: (dz) => {
      dropzoneRef.current = dz;
    },
    success,
    error: handleError,
    complete: handleComplete,
    addedfile: handleAddedFile
  };

  const djsConfig = {
    dictDefaultMessage: '',
    addRemoveLinks: false,
    uploadMultiple: false,
    maxFilesize: parseInt(maxUploadSize),
    acceptedFiles: 'image/jpeg,image/png,image/jpg',
    dictMaxFilesExceeded: 'Remove the existing image and try upload again',
    previewsContainer: false,
    hiddenInputContainer: '.dzInputContainer',
    timeout: 300000,
    maxFiles: 1
  };

  return (
    <div className={className}>
      <div className={cx('dzInputContainer', 'adminPrimaryBtnBaseDropZoneContainer')}>
        <DropzoneComponent
          config={componentConfig}
          eventHandlers={eventHandlers}
          djsConfig={djsConfig}
        >
          {defaultMessage}
        </DropzoneComponent>
      </div>
      {subText && <p className='uploadNotifyText'>{subText}: {maxUploadSize}MB</p>}
    </div>
  );
};

const mapState = state => ({
  maxUploadSize: state.siteSettings.data.maxUploadSize
});

const mapDispatch = {
  setLoaderStart,
  setLoaderComplete
};

export default withStyles(s)(connect(mapState, mapDispatch)(ImageUploadComponent));
